import { useId } from 'react'
import { cn } from '../lib/cn'

/**
 * Bildmarke von NetCon Work – ein W, dessen rechte Hälfte ein Haken ist.
 *
 * Quelle ist `apps/web/public/netcon-work-mark.svg` (Markenkit). Hier liegt sie
 * zusätzlich inline, weil das Zeichen in der Seitenleiste beim ersten Render
 * sofort da sein muss (Leitplanke 4: kein Nachladen, kein Springen).
 * Wer die Datei im Kit ändert, ändert sie auch hier.
 *
 * Die Verlaufs-IDs sind pro Instanz eindeutig – sonst greifen mehrere
 * eingebettete SVGs auf dieselben `defs` zu.
 */
export function Marke({ className }: { className?: string }) {
  const id = useId()
  const bg = `${id}-bg`
  const glow = `${id}-glow`
  const chk = `${id}-chk`

  return (
    <svg
      viewBox="0 0 512 512"
      className={cn('shrink-0', className)}
      role="img"
      aria-label="NetCon Work"
    >
      <defs>
        <linearGradient id={bg} x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2F80E4" />
          <stop offset="0.55" stopColor="#3B5BD0" />
          <stop offset="1" stopColor="#4A3AA7" />
        </linearGradient>
        <radialGradient id={glow} cx="0.28" cy="0.2" r="0.9">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.18" />
          <stop offset="0.5" stopColor="#ffffff" stopOpacity="0.04" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={chk} x1="268" y1="290" x2="414" y2="168" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.6" stopColor="#ffffff" />
          <stop offset="1" stopColor="#8FF2CE" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="512" height="512" rx="114" fill={`url(#${bg})`} />
      <rect x="0" y="0" width="512" height="512" rx="114" fill={`url(#${glow})`} />

      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="54">
        <path d="M100 168 L176 346 L250 176" stroke="#ffffff" strokeOpacity="0.94" />
        <path d="M268 290 L326 346 L414 168" stroke={`url(#${chk})`} />
      </g>
    </svg>
  )
}
